module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "reject-modal-template"
    }
  }, [_c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper reject-modal"
  }, [_c('div', {
    staticClass: "modal-container md-modal-container"
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('h2', {
    staticClass: "show-title"
  }, [_vm._v("반려")]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered text-center table-system-authority-roles"
  }, [_c('caption', [_vm._v("커뮤니티 반려 대상 정보")]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "width": "90%"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("반려대상 : ")]), _vm._v(" "), _vm._l((_vm.nameList), function(list) {
    return _c('span', {
      staticClass: "reciever-tag"
    }, [_vm._v(_vm._s(list) + "  ")])
  })], 2)])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "width": "90%"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("반려내용 : ")])])])]), _c('tr', [_c('td', {
    staticStyle: {
      "width": "100%",
      "height": "200px"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reason),
      expression: "reason"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "98%",
      "height": "98%"
    },
    attrs: {
      "rows": "2",
      "title": "결과 입력"
    },
    domProps: {
      "value": (_vm.reason)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.reason = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "hidden",
      "name": "reject"
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "hidden",
      "name": "memId"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "attendance-action"
  }, [_c('button', {
    staticClass: "sm-btn btn--blue-line",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("저장")]), _vm._v(" "), _c('button', {
    staticClass: "sm-btn btn--blue-line",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("닫기")])])])])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-597c79dc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/main/community/MemberRejectButton.vue
// module id = 1407
// module chunks = 6